<header class="header">
  <div class="header-container">
    <div class="logo-wrapper">
      <a class="navbar-brand" 
        routerLink="{{ headerNavData?.brand?.link }}"
        [queryParamsHandling]="'preserve'"
        ><img
          fetchpriority="high"
          src="{{ headerNavData?.brand?.img }}"
          alt="{{ headerNavData?.brand?.logoAction }}"
          class="logo"
      /></a>
    </div>
    <nav class="nav-left collapse navbar-collapse" *ngIf="!hideMainNav">
      <div class="nav-menu-top-mobile">
        <a 
          (click)="toggleMenu()"
          class="navbar-brand" 
          routerLink="{{ headerNavData?.brand?.link }}"
          [queryParamsHandling]="'preserve'"
          ><img
            fetchpriority="high"
            src="{{ headerNavData?.brand?.img }}"
            alt="{{ headerNavData?.brand?.logoAction }}"
            class="logo"
        /></a>
        <button
          class="navbar-toggler close-icon"
          type="button"
          (click)="toggleMenu()"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div class="nav-list-wrapper">
        <ul class="nav-list">
          <li
            [ngClass]="{
              'has-children': mainmenu?.fields?.headerSubsectionReference,
            }"
            *ngFor="let mainmenu of headerNavData?.menu; index as j"
          >
            <div
              class="nav-link weblink child-link"
              *ngIf="
                mainmenu?.fields?.title !== 'Pricing' &&
                mainmenu?.fields?.title !== 'Developers'
              "
              (click)="
                openLink(
                  !mainmenu?.fields?.headerSubsectionReference ? 'pricing' : '',
                  mainmenu?.fields?.title
                )
              "
              (mouseover)="onMouseOverRoot($event.target)"
            >
              {{ mainmenu?.fields?.title }}
            </div>
            
            <a
              *ngIf="mainmenu?.fields?.title === 'Pricing'"
              class="nav-link weblink"
              href="{{ mainmenu?.fields?.subsectionHeader1Link | urlParams:queryParams }}"
              (mouseover)="onMouseOverRoot($event.target)"
              (click)="onNavItemClick('header', 'pricing', mainmenu?.fields?.subsectionHeader1Link)"
            >
              {{ mainmenu?.fields?.title }}
            </a>
            <a
              *ngIf="mainmenu?.fields?.title === 'Developers'"
              class="nav-link weblink"
              href="{{ mainmenu?.fields?.subsectionHeader1Link | urlParams:queryParams }}"
              (mouseover)="onMouseOverRoot($event.target)"
              (click)="onNavItemClick('header', 'developers', mainmenu?.fields?.subsectionHeader1Link)"
            >
              {{ mainmenu?.fields?.title }}
            </a>
            <div
              class="sub_menu sub_menu_mobile {{ mainmenu.fields.title }}"
              *ngIf="mainmenu?.fields?.headerSubsectionReference"
            >
              <div class="section-container">
                <div class="sub_menu_l2">
                  <ul
                    class="main-ul-class nav"
                    orientation="vertical"
                    [ngClass]="{
                      'fourth-class': mainmenu?.fields?.title === 'Coverage',
                    }"
                  >
                    <li
                      *ngFor="
                        let submenu of getCombinedHeaderSubsectionReferences(
                          mainmenu
                        );
                        let i = index
                      "
                      [ngClass]="{
                        'third-element':
                          i === 2 &&
                          submenu?.fields?.subSectionTitle ===
                            'PRODUCT ANNOUNCEMENTS',
                      }"
                    >
                      <div class="flex-v2">
                        <div
                          *ngIf="mainmenu?.fields?.title !== 'Coverage'"
                          class="subSection"
                        >
                          {{ submenu?.fields?.subSectionTitle }}
                        </div>
                        <div
                          *ngIf="mainmenu?.fields?.title === 'Coverage'"
                          class="subSection"
                        >
                          {{ submenu?.fields?.subsectionHeader }}
                        </div>
                      </div>
                      <div
                        *ngIf="mainmenu?.fields?.title === 'Coverage'"
                        class="subSection"
                      >
                        <div *ngIf="i === 0">
                          {{ mainmenu?.fields?.subsectionHeader }}
                        </div>
                        <div *ngIf="i === 2">
                          {{ mainmenu?.fields?.subsectionHeader2 }}
                        </div>
                      </div>
                      <div *ngIf="mainmenu?.fields?.title === 'Coverage'">
                        <div *ngIf="i === 0">
                          <hr />
                        </div>
                        <div *ngIf="i === 1" class="divider">
                          <hr />
                        </div>
                        <div *ngIf="i === 2">
                          <hr />
                        </div>
                        <div *ngIf="i === 3" class="divider">
                          <hr />
                        </div>
                      </div>
                      <div *ngIf="mainmenu?.fields?.title !== 'Coverage'">
                        <hr />
                      </div>

                      <div class="linkedPagesClass">
                        <div
                          *ngFor="
                            let item of submenu?.fields?.linkedPagesReferences
                          "
                          class="sub_menu_item"
                        >
                          <a 
                            href="{{item?.fields?.redirectLink | urlParams:queryParams}}"
                            (click)="onNavItemClick(mainmenu?.fields?.title, item?.fields?.subSectionTitle, item?.fields?.redirectLink, submenu?.fields?.subSectionTitle || submenu?.fields?.subsectionHeader)"
                          >
                            <img
                              fetchpriority="low"
                              loading="lazy"
                              [ngClass]="{
                                'fourth-class-image no-filter':
                                  mainmenu?.fields?.title === 'Coverage',
                                'solutions-image':
                                  mainmenu?.fields?.title === 'Solutions',
                                'products-image':
                                  mainmenu?.fields?.title === 'Products',
                                'company-image':
                                  mainmenu?.fields?.title === 'Company',
                              }"
                              [src]="
                                item?.fields?.subSectionIcon?.fields?.file.url
                              "
                              alt=""
                            />
                            <div>
                              <div
                                class="subSectionTitleClass"
                                [ngClass]="{
                                  'fourth-class-subSectionTitleClass':
                                    mainmenu?.fields?.title === 'Coverage',
                                }"
                              >
                                {{ item.fields.subSectionTitle }}
                              </div>
                              <div class="grayClass">
                                {{ item.fields.shortDescription }}
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="menu_card_wrapper"></div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <nav class="nav-right">
      <ul class="nav-list">
        <li>
          <a
            class="nav-link"
            href="{{ headerNavData?.button1?.url | urlParams:queryParams}}"
            target="{{ headerNavData?.button1?.target }}"
            (click)="onLoginClick()"
            >{{ headerNavData?.button1?.text }}</a
          >
        </li>
        <li>
          <a 
            href="{{headerNavData?.button2?.url | urlParams:queryParams}}" 
            class="btn btn-full"
            (click)="onGetStartedClick()"
            >{{headerNavData?.button2?.text}}
          </a>
        </li>
      </ul>
      <div class="hide-menu mar-l-16" *ngIf="!hideMainNav">
        <button class="navbar-toggler" type="button" (click)="toggleMenu()">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
  </div>
</header>
